import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";

export default function Login() {
    const { login } = useApp();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const u = await login(email, password);
            toast.success(`Bentornato/a, ${u.name}`);
            navigate(u.role === "admin" ? "/admin" : "/account");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Accesso non riuscito");
        } finally {
            setSubmitting(false);
        }
    };

    const loginGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/account";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="px-6 py-20 max-w-md mx-auto" data-testid="login-page">
            <div className="overline mb-3">Account</div>
            <h1 className="font-display text-5xl tracking-tight text-[color:var(--ms-charcoal)] mb-3">Accedi</h1>
            <p className="text-[color:var(--ms-muted)] text-sm mb-10">Bentornato/a in Mini Style.</p>
            <form onSubmit={onSubmit} className="space-y-5">
                <Input label="Email" type="email" value={email} onChange={setEmail} testid="login-email" />
                <Input label="Password" type="password" value={password} onChange={setPassword} testid="login-password" />
                <button type="submit" disabled={submitting} className="w-full bg-[color:var(--ms-charcoal)] text-[color:var(--ms-warm-white)] py-4 text-xs tracking-[0.22em] font-medium hover:bg-[color:var(--ms-sage-dark)] transition-colors disabled:opacity-50" data-testid="login-submit">
                    {submitting ? "ACCESSO IN CORSO…" : "ACCEDI"}
                </button>
            </form>
            <div className="flex items-center gap-3 my-8 text-[color:var(--ms-muted)] text-xs tracking-[0.2em]">
                <span className="flex-1 border-t border-[color:var(--ms-border)]" /> OPPURE <span className="flex-1 border-t border-[color:var(--ms-border)]" />
            </div>
            <button onClick={loginGoogle} className="w-full border border-[color:var(--ms-charcoal)] text-[color:var(--ms-charcoal)] py-4 text-xs tracking-[0.22em] hover:bg-[color:var(--ms-charcoal)] hover:text-[color:var(--ms-warm-white)] transition-colors" data-testid="login-google">
                CONTINUA CON GOOGLE
            </button>
            <p className="text-center mt-8 text-sm text-[color:var(--ms-muted)]">
                Non hai un account? <Link to="/register" className="text-[color:var(--ms-sage-dark)] link-underline" data-testid="login-register-link">Registrati</Link>
            </p>
        </div>
    );
}

export const Input = ({ label, type = "text", value, onChange, testid }) => (
    <div>
        <label className="overline block mb-2">{label}</label>
        <input
            type={type}
            value={value}
            onChange={e => onChange(e.target.value)}
            required
            className="w-full bg-[color:var(--ms-warm-white)] border border-[color:var(--ms-border)] focus:border-[color:var(--ms-charcoal)] px-3 py-3 text-sm outline-none text-[color:var(--ms-charcoal)]"
            data-testid={testid}
        />
    </div>
);
